import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import "core-js/modules/esnext.global-this.js";
// pkg/dist-src/index.js
import { endpoint } from "@octokit/endpoint";
import { getUserAgent } from "universal-user-agent"; // pkg/dist-src/version.js

var VERSION = "8.1.6"; // pkg/dist-src/is-plain-object.js

function isPlainObject(value) {
  if (typeof value !== "object" || value === null) return false;
  if (Object.prototype.toString.call(value) !== "[object Object]") return false;
  var proto = Object.getPrototypeOf(value);
  if (proto === null) return true;
  var Ctor = Object.prototype.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  return typeof Ctor === "function" && Ctor instanceof Ctor && Function.prototype.call(Ctor) === Function.prototype.call(value);
} // pkg/dist-src/fetch-wrapper.js


import { RequestError } from "@octokit/request-error"; // pkg/dist-src/get-buffer-response.js

function getBufferResponse(response) {
  return response.arrayBuffer();
} // pkg/dist-src/fetch-wrapper.js


function fetchWrapper(requestOptions) {
  var _requestOptions$reque, _requestOptions$reque2, _requestOptions$reque3;

  var log = requestOptions.request && requestOptions.request.log ? requestOptions.request.log : console;
  var parseSuccessResponseBody = ((_requestOptions$reque = requestOptions.request) === null || _requestOptions$reque === void 0 ? void 0 : _requestOptions$reque.parseSuccessResponseBody) !== false;

  if (isPlainObject(requestOptions.body) || Array.isArray(requestOptions.body)) {
    requestOptions.body = JSON.stringify(requestOptions.body);
  }

  var headers = {};
  var status;
  var url;
  var fetch = globalThis.fetch;

  if ((_requestOptions$reque2 = requestOptions.request) !== null && _requestOptions$reque2 !== void 0 && _requestOptions$reque2.fetch) {
    fetch = requestOptions.request.fetch;
  }

  if (!fetch) {
    throw new Error("fetch is not set. Please pass a fetch implementation as new Octokit({ request: { fetch }}). Learn more at https://github.com/octokit/octokit.js/#fetch-missing");
  }

  return fetch(requestOptions.url, _objectSpread({
    method: requestOptions.method,
    body: requestOptions.body,
    headers: requestOptions.headers,
    signal: (_requestOptions$reque3 = requestOptions.request) === null || _requestOptions$reque3 === void 0 ? void 0 : _requestOptions$reque3.signal
  }, requestOptions.body && {
    duplex: "half"
  })).then( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response) {
      var _iterator, _step, keyAndValue, matches, deprecationLink, data, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = response.url;
              status = response.status;
              _iterator = _createForOfIteratorHelper(response.headers);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  keyAndValue = _step.value;
                  headers[keyAndValue[0]] = keyAndValue[1];
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              if ("deprecation" in headers) {
                matches = headers.link && headers.link.match(/<([^>]+)>; rel="deprecation"/);
                deprecationLink = matches && matches.pop();
                log.warn("[@octokit/request] \"".concat(requestOptions.method, " ").concat(requestOptions.url, "\" is deprecated. It is scheduled to be removed on ").concat(headers.sunset).concat(deprecationLink ? ". See ".concat(deprecationLink) : ""));
              }

              if (!(status === 204 || status === 205)) {
                _context.next = 7;
                break;
              }

              return _context.abrupt("return");

            case 7:
              if (!(requestOptions.method === "HEAD")) {
                _context.next = 11;
                break;
              }

              if (!(status < 400)) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              throw new RequestError(response.statusText, status, {
                response: {
                  url: url,
                  status: status,
                  headers: headers,
                  data: void 0
                },
                request: requestOptions
              });

            case 11:
              if (!(status === 304)) {
                _context.next = 24;
                break;
              }

              _context.t0 = RequestError;
              _context.t1 = status;
              _context.t2 = url;
              _context.t3 = status;
              _context.t4 = headers;
              _context.next = 19;
              return getResponseData(response);

            case 19:
              _context.t5 = _context.sent;
              _context.t6 = {
                url: _context.t2,
                status: _context.t3,
                headers: _context.t4,
                data: _context.t5
              };
              _context.t7 = requestOptions;
              _context.t8 = {
                response: _context.t6,
                request: _context.t7
              };
              throw new _context.t0("Not modified", _context.t1, _context.t8);

            case 24:
              if (!(status >= 400)) {
                _context.next = 30;
                break;
              }

              _context.next = 27;
              return getResponseData(response);

            case 27:
              data = _context.sent;
              error = new RequestError(toErrorMessage(data), status, {
                response: {
                  url: url,
                  status: status,
                  headers: headers,
                  data: data
                },
                request: requestOptions
              });
              throw error;

            case 30:
              if (!parseSuccessResponseBody) {
                _context.next = 36;
                break;
              }

              _context.next = 33;
              return getResponseData(response);

            case 33:
              _context.t9 = _context.sent;
              _context.next = 37;
              break;

            case 36:
              _context.t9 = response.body;

            case 37:
              return _context.abrupt("return", _context.t9);

            case 38:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }()).then(function (data) {
    return {
      status: status,
      url: url,
      headers: headers,
      data: data
    };
  }).catch(function (error) {
    if (error instanceof RequestError) throw error;else if (error.name === "AbortError") throw error;
    var message = error.message;

    if (error.name === "TypeError" && "cause" in error) {
      if (error.cause instanceof Error) {
        message = error.cause.message;
      } else if (typeof error.cause === "string") {
        message = error.cause;
      }
    }

    throw new RequestError(message, 500, {
      request: requestOptions
    });
  });
}

function getResponseData(_x2) {
  return _getResponseData.apply(this, arguments);
}

function _getResponseData() {
  _getResponseData = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(response) {
    var contentType;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            contentType = response.headers.get("content-type");

            if (!/application\/json/.test(contentType)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", response.json().catch(function () {
              return response.text();
            }).catch(function () {
              return "";
            }));

          case 3:
            if (!(!contentType || /^text\/|charset=utf-8$/.test(contentType))) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", response.text());

          case 5:
            return _context2.abrupt("return", getBufferResponse(response));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getResponseData.apply(this, arguments);
}

function toErrorMessage(data) {
  if (typeof data === "string") return data;

  if ("message" in data) {
    if (Array.isArray(data.errors)) {
      return "".concat(data.message, ": ").concat(data.errors.map(JSON.stringify).join(", "));
    }

    return data.message;
  }

  return "Unknown error: ".concat(JSON.stringify(data));
} // pkg/dist-src/with-defaults.js


function withDefaults(oldEndpoint, newDefaults) {
  var endpoint2 = oldEndpoint.defaults(newDefaults);

  var newApi = function newApi(route, parameters) {
    var endpointOptions = endpoint2.merge(route, parameters);

    if (!endpointOptions.request || !endpointOptions.request.hook) {
      return fetchWrapper(endpoint2.parse(endpointOptions));
    }

    var request2 = function request2(route2, parameters2) {
      return fetchWrapper(endpoint2.parse(endpoint2.merge(route2, parameters2)));
    };

    Object.assign(request2, {
      endpoint: endpoint2,
      defaults: withDefaults.bind(null, endpoint2)
    });
    return endpointOptions.request.hook(request2, endpointOptions);
  };

  return Object.assign(newApi, {
    endpoint: endpoint2,
    defaults: withDefaults.bind(null, endpoint2)
  });
} // pkg/dist-src/index.js


var request = withDefaults(endpoint, {
  headers: {
    "user-agent": "octokit-request.js/".concat(VERSION, " ").concat(getUserAgent())
  }
});
export { request };